import { RegModalGames } from '@/components/_promo/components/RegModalGames';
import type { RegistrationConfig } from '../types';
import { DARKLE_REG_CONFIG } from './darkle';

export const DARKLE_REG_GAMES_CONFIG: RegistrationConfig = {
  ...DARKLE_REG_CONFIG,
  hideSteps: true,
  customBottomBlock: {
    render: () => <RegModalGames />,
  },
};
